export const PLANALTO_LC123_URL = 'https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp123.htm';

export const RECEITA_SIMPLES_ANEXO_I_URL =
  'http://normas.receita.fazenda.gov.br/sijut2consulta/anexoOutros.action?idArquivoBinario=48430';

export const CGSN_RESOLUCAO_140_URL =
  'http://normas.receita.fazenda.gov.br/sijut2consulta/link.action?visao=anotado&idAto=115262';

export const SIMPLES_GOLDEN_ANEXO_COMERCIO = 'I';
export const SIMPLES_GOLDEN_ANEXO_SERVICOS = 'III';
export const SIMPLES_GOLDEN_ANEXO_PROFISSIONAIS = 'V';

export const SIMPLES_MIN_ANEXOS = 5;
export const SIMPLES_MAX_ANEXOS = 5;
export const SIMPLES_FAIXAS_POR_ANEXO = 6;

export const SIMPLES_MAX_RBT12 = 4_800_000;
